import React from 'react';
import { api } from '../services/api';
import { printerService } from '../services/printer';

function BadgePreview({ registration, onPrintComplete, onCancel }) {
    const [printing, setPrinting] = React.useState(false);
    const [error, setError] = React.useState('');

    const handlePrint = async () => {
        setPrinting(true);
        setError('');

        try {
            // Generate ZPL
            const { zpl } = await api.generateZPL(registration);
            
            // Print via BrowserPrint
            await printerService.printZPL(zpl);
            
            // Success
            onPrintComplete(registration);
        } catch (err) {
            setError(err.message || 'Print failed');
            setPrinting(false);
        }
    };

    const displayValue = (value) => {
        return (value && value.toString().trim()) || 'N/A';
    };

    return (
        <div className="badge-preview">
            <h2>Badge Preview</h2>
            
            <div className="badge-details">
                {registration.eventName && (
                    <div className="badge-field">
                        <label>Event:</label>
                        <span><b>{registration.eventName}</b></span>
                    </div>
                )}
                <div className="badge-field">
                    <label>Name:</label>
                    <span>{registration.name}</span>
                </div>
                <div className="badge-field">
                    <label>Title:</label>
                    <span>{displayValue(registration.title)}</span>
                </div>
                <div className="badge-field">
                    <label>Company:</label>
                    <span>{displayValue(registration.company)}</span>
                </div>
                <div className="badge-field">
                    <label>Country:</label>
                    <span>{displayValue(registration.country)}</span>
                </div>
                <div className="badge-field">
                    <label>Type:</label>
                    <span>{registration.type}</span>
                </div>
                <div className="badge-field">
                    <label>QR Code:</label>
                    <span style={{ fontFamily: 'monospace', fontSize: '0.9rem' }}>
                        {registration.qrCode}
                    </span>
                </div>
            </div>

            {error && (
                <div className="message error">
                    {error}
                </div>
            )}

            <div className="print-actions">
                <button 
                    className="print-btn"
                    onClick={handlePrint}
                    disabled={printing}
                >
                    {printing ? 'Printing...' : '🖨️ Print Badge'}
                </button>
                <button 
                    className="cancel-btn"
                    onClick={onCancel}
                    disabled={printing}
                >
                    Back
                </button>
            </div>
        </div>
    );
}

export default BadgePreview;
